import { forwardRef, useId, type InputHTMLAttributes } from 'react';

export interface FloatingLabelProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

/** Bootstrap 5 floating-label input (label animates above the field on focus/fill). */
export const FloatingLabel = forwardRef<HTMLInputElement, FloatingLabelProps>(function FloatingLabel(
  { label, id, className = '', ...rest },
  ref,
) {
  const autoId = useId();
  const fieldId = id ?? autoId;
  return (
    <div className="form-floating">
      {/* Floating labels require a placeholder on the control. */}
      <input id={fieldId} ref={ref} className={`form-control ${className}`.trim()} placeholder={label} {...rest} />
      <label htmlFor={fieldId}>{label}</label>
    </div>
  );
});
